import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { MODULES, SECTION_LABEL, moduleById, type ModuleDef, type ModuleSection, type identity } from '@cathouse/contracts';
import { http, qk } from '@/shared/api';
import { applyBrand } from '@/shared/lib';

export { MODULES, SECTION_LABEL, moduleById };
export type { ModuleDef, ModuleSection };
export type TenantSettings = identity.TenantSettings;

export const moduleByRoute = (route: string) => MODULES.find((m) => m.route === route);
export const SECTION_ORDER: ModuleSection[] = ['command', 'source', 'sales', 'deals', 'performance', 'finance', 'system'];
/** Số tầng của "Quy trình vận hành" theo nhóm menu (prototype src/core/registry.js SECTIONS.layer); Điều hành / Hệ thống không có. */
export const SECTION_LAYER: Partial<Record<ModuleSection, number>> = { source: 1, sales: 2, deals: 3, performance: 4, finance: 5 };

export interface SettingsEnvelope {
  version: number;
  settings: TenantSettings;
  enabledModules: string[];
}
export const useTenantSettings = () => useQuery({ queryKey: qk.tenant.settings(), queryFn: () => http.get<SettingsEnvelope>('/tenant/settings') });

export interface Branding {
  slug: string;
  name: string | null;
  logoUrl: string | null;
  /** Logo cho nền tối (bản trắng); null ⇒ chưa có. */
  logoDarkUrl: string | null;
  brand: string;
  brand2: string;
  ready: boolean;
}
export const useBranding = (slug: string) =>
  useQuery({ queryKey: qk.tenant.branding(slug), queryFn: () => http.get<Branding | null>(`/tenants/${encodeURIComponent(slug)}/branding`), enabled: slug.length >= 3, staleTime: 5 * 60_000 });

/** Áp màu công ty cho toàn bộ giao diện (token CSS tự đạt tương phản AA). */
export function useBrandColors(brand?: string | null, brand2?: string | null) {
  useEffect(() => {
    if (brand && brand2) applyBrand(brand, brand2);
  }, [brand, brand2]);
}
